import React from 'react';
import { Button, BackButton, ResultValue, PrintButton } from '../Components/Simple';
import { BasicInformation, ClaimDetails, FactorAndAdjustments, PricingErrors, ServiceLineItems } from '../Components/Combined/Results';
import { HH as modelType } from '../Constants/modelTypes';
import { formatStringAsCurrency, cleanUpNumberString, formatDateString } from '../Utils/stringUtils';
import { API_DATE_STRING_FORMAT, DATE_STRING_FORMAT } from '../Constants/stringFormats.js';
import { useNavigate, useLocation } from 'react-router-dom';
import usePrintOrientation from '../Hooks/usePrintOrientation';
import PaymentComponents from '../Components/Combined/Results/PaymentComponents';
import Protect from '../Components/Combined/Protect';
import { HIDE } from '../Constants/protectionBehaviors';
import { EOB_VIEW } from '../Constants/moduleNames';
import { enableEOB } from '../Utils/features';

export default function HHResult() {
    const [_orientation, _setOrientation] = usePrintOrientation('landscape');
    const location = useLocation();
    const navigate = useNavigate();
    const { result, providerName, calendarYear, billedAmountTotal } = location.state;

    const processedDate = new Date();

    const handleNavigateToEOBGenerator = () => {
        const fromDate = formatDateString(result.fromDate, API_DATE_STRING_FORMAT, DATE_STRING_FORMAT)
        const toDate = fromDate && formatDateString(result.toDate, API_DATE_STRING_FORMAT, DATE_STRING_FORMAT)
        navigate('/EOB', {
            state: {
                processedDate,
                pricerType: modelType,
                lines: [{
                    dateOfService: toDate && `${fromDate} - ${toDate}`,
                    serviceCode: "",
                    serviceDescription: "Home Health Services",
                    qty: "",
                    billedAmount: parseFloat(cleanUpNumberString(billedAmountTotal)) || 0,
                    allowedAmount: parseFloat(result.medicareAllowed) || 0,
                    initialMaxShiftAmount: 0
                }]
            }
        })
    }

    return (<div className="py-2">
        <div className="row g-0 sticky top border-bottom">
            <div className="row justify-content-between g-0">
                <div className="col-auto">
                    <PrintButton />
                </div>
                <div className="col-auto">
                    <Protect module={EOB_VIEW} behavior={HIDE} >
                        {enableEOB && <Button className="btn btn-success" onClick={handleNavigateToEOBGenerator} text="Generate EOB" />}
                    </Protect>
                </div>
                <div className="col-auto">
                    <BackButton />
                </div>
            </div>
            <div className="row my-2 g-0">
                <div className="col">
                    <h2>Home Health Pricer - Pricing Outputs</h2>
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-md-6">
                <ResultValue label="Medicare Allowed Amount" value={formatStringAsCurrency(result.medicareAllowed)} labelClassName="fs-4 fw-500" valueClassName="fs-4 fw-500" />
            </div>
        </div>
        <PricingErrors result={result} totalMedicareAllowed={result.medicareAllowed} />
        <div className="row my-2">
            <div className="col-md-6">
                <BasicInformation calendarYear={calendarYear} inputProviderName={providerName} result={result} model={modelType} processedDate={processedDate} />
            </div>
        </div>
        <div className="row my-2">
            <div className="col-md">
                <ClaimDetails result={result} model={modelType} />
            </div>
            <div className="col-md">
                <FactorAndAdjustments result={result} model={modelType} calendarYear={calendarYear} />
            </div>
        </div>
        <div className="row my-2">
            <div className="col-md-6">
                <PaymentComponents result={result} model={modelType} calendarYear={calendarYear} />
            </div>
        </div>
        <div className="page-break-here"></div>
        <div className="row my-2">
            <div className="col">
                <ServiceLineItems result={result} model={modelType} />
            </div>
        </div>
    </div>
    );
}
